import service from '../api/summary.service';
//constants
const data = {
    summaryDocuments: [],
    dataXls: [],
    summaryError: '',
    summaryRows: 0
}
//types
const SUMMARY_LIST = 'SUMMARY_LIST';
const EXPORT_LIST = 'EXPORT_LIST';
const SUMMARY_ERROR = 'SUMMARY_ERROR';
const SUMMARY_COUNT = 'SUMMARY_COUNT';
const SUMMARY_CLEAN = 'SUMMARY_CLEAN';

//reducer
export default function summaryReducer(state = data, action) {
    switch (action.type) {
        case SUMMARY_LIST:
            return { ...state, summaryDocuments: action.payload };
        case EXPORT_LIST:
            return { ...state, dataXls: action.payload };
        case SUMMARY_ERROR:
            return { ...state, summaryError: action.payload };
        case SUMMARY_COUNT:
            return { ...state, summaryRows: action.payload };
        case SUMMARY_CLEAN:
            return { ...state, summaryRows: 0,summaryDocuments:[],dataXls: [] };
        default:
            return { ...state };
    }
}
export const cleanSummary = () => async (dispatch) => {
    dispatch({
        type: SUMMARY_CLEAN,
        payload: []
    });
}

export const getSummaryTotal = (json, username) => async (dispatch) => {

    const response = await service.getSummaryTotal(json, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    if (response.code !== undefined) {
        dispatch({
            type: SUMMARY_ERROR,
            payload: response
        });
        dispatch({
            type: SUMMARY_LIST,
            payload: []
        });
    } else {

        dispatch({
            type: SUMMARY_ERROR,
            payload: ''
        });
        dispatch({
            type: SUMMARY_LIST,
            payload: response
        });
    }

}
export const getRowTotal = (json) => async (dispatch) => {

    const response = await service.getRowTotal(json).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    if (response.code !== undefined) {
        dispatch({
            type: SUMMARY_ERROR,
            payload: response
        });
        dispatch({
            type: SUMMARY_COUNT,
            payload: 0
        });
    } else {

        dispatch({
            type: SUMMARY_ERROR,
            payload: ''
        });
        dispatch({
            type: SUMMARY_COUNT,
            payload: response
        });
    }

}
export const exportToXls = (json, username) => async (dispatch) => {

    const response = await service.getSummaryTotal(json, username).then((r) => {
        return r.data !== undefined ? r.data : r.response.data;
    });
    if (response.code !== undefined) {
        dispatch({
            type: SUMMARY_ERROR,
            payload: response
        });
        dispatch({
            type: EXPORT_LIST,
            payload: []
        });
    } else {

        dispatch({
            type: SUMMARY_ERROR,
            payload: ''
        });
        dispatch({
            type: EXPORT_LIST,
            payload: response
        });
    }

}
